<template><svg  viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.06055 1.72003L1.71388 6.0667C1.20055 6.58003 1.20055 7.42003 1.71388 7.93336L6.06055 12.28" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>